import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/**
 * 404 error page component.
 *
 * @remarks Displays a user-friendly 404 error page when users navigate to
 * a route that doesn't exist. Provides navigation options to help users
 * find the content they're looking for.
 */
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class PageNotFoundComponent {
  /**
   * Creates an instance of PageNotFoundComponent.
   */
  constructor() {}
}
